function Checkbox() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="checkbox-circle-fill">
        <path
          id="Vector"
          d="M8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99998C1.3335 4.31808 4.31826 1.33331 8.00016 1.33331C11.682 1.33331 14.6668 4.31808 14.6668 7.99998C14.6668 11.6818 11.682 14.6666 8.00016 14.6666ZM7.33523 10.6666L12.0493 5.9526L11.1065 5.00979L7.33523 8.78105L5.44964 6.89538L4.50682 7.83825L7.33523 10.6666Z"
          fill="#00B383"
        />
      </g>
    </svg>
  );
}

export default Checkbox;
